import React, {useState, useEffect} from "react";
import ProductLayout from "../components/product-layout";
import {useApplicationContext} from '../provider'
import {getContent} from '../react-hooks/useContentCompiler'
// import rawTemplate from '../compiled/braintree/templates/home/developers/index.hbs';
const Product = (props) => {
  
const {pathContext: {config} } = props
const [productContext, setProductContext] = useState({});
const [homeContent, setHomeContent] = useState('')
const { handleBarCompiler } = useApplicationContext()

const rawTemplate = require(`raw-loader!../compiled/braintree/templates/home/developers/index.hbs`)
useEffect(()=>{
  const context = window.BTHandlebarLib.initialize({location:props.location})
  window.BTHandlebarLib.setHomePageTitle({context})
      // eslint-disable-next-line react-hooks/rules-of-hooks
  setHomeContent(getContent(rawTemplate, handleBarCompiler, context))
  setProductContext(context)
},[])
  return (
    <ProductLayout  hideRightNav hideLeftNav hideMenu config={config} isProductPage location={props.location} context={productContext}>
        <div dangerouslySetInnerHTML={{__html: homeContent}}/>
    </ProductLayout>
  );
};

export default Product
